<div class="hb-container hb-container--width-lg">
  <div class="hb-grid hb-mb--xl">
    <div class="hb-cell hb-cell--12of12 hb-cell--3of12@md">
      <stat-filter (selectedFilters)="filterVisning($event)" seksjon="kommuneside"></stat-filter>
    </div>
    <div class="hb-cell hb-cell--12of12 hb-cell--9of12@md">
      <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Sammenlikning</h1>
      <hb-accordion class="hb-mb--lg">
        <hb-accordion-element id="sammenligningID">
          <h2 title class="hb-accordion-tittel">Om sammenlikning</h2>
          <div body="">
            <p>Denne siden gir deg mulighet til å sammenlikne nøkkeltall for flere kommuner.</p>
            <p>Standard innstilling på periode er hittil i år. Velger du flere perioder vil nøkkeltallene summeres.</p>
            <p>Du kan sortere tabellinnholdet etter størrelse ved å trykke på kolonneoverskriftene.</p>
            <p><strong>Merk:</strong> Dersom det er færre enn 4 observasjoner vises ikke detaljene for alle ordningene. Dette er for å ivareta personvernhensynet.</p>
          </div>
        </hb-accordion-element>
      </hb-accordion>

      <div class="hb-grid">
        <ng-container>
          <stat-qlik-table
            id="hovedtall-startlån-pr-kommune"
            class="hb-cell hb-cell--12of12"
            [omHovedtall]="'Tabellen viser nøkkeltall for startlån '"
            [height]="350"
            [visExcel]="true"
            [valgtFilter]="valgtFilter"
            [noSelections]="true"
          >
          </stat-qlik-table>
          <stat-qlik-table
            id="hovedtall-bostøtte-pr-kommune"
            class="hb-cell hb-cell--12of12"
            [omHovedtall]="'Tabellen viser nøkkeltall for bostøtte '"
            [height]="350"
            [visExcel]="true"
            [valgtFilter]="valgtFilter"
            [noSelections]="true"
          >
          </stat-qlik-table>
          <stat-qlik-table
            id="hovedtall-lån-og-tilskudd-pr-kommune"
            class="hb-cell hb-cell--12of12"
            [omHovedtall]="'Tabellen viser nøkkeltall for kommunalt disponerte boliger'"
            [height]="350"
            [visExcel]="true"
            [valgtFilter]="valgtFilter"
            [noSelections]="true"
          >
          </stat-qlik-table>
        </ng-container>
      </div>
    </div>
  </div>
</div>
